export default __webpack_public_path__ + "static/background.repairClothes-34b041e8dc79ee404f5a50b63df9bba2.jpg";